var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "User") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Badge/Icon-9",
    transform: "translate(-7.000000, -7.000000)",
    stroke: "#989FB2",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "User",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8369565,4.29130435 C14.9282609,1.87173913 12.873913,0 10.5,0 C8.12608696,0 6.02608696,1.9173913 6.16304348,4.29130435 C6.20869565,4.79347826 6.66521739,7.1673913 6.66521739,7.1673913 C7.03043478,9.22173913 8.4,10.9565217 10.5,10.9565217 C12.6,10.9565217 13.9695652,9.22173913 14.3347826,7.12173913 C14.3347826,7.12173913 14.7913043,4.74782609 14.8369565,4.29130435 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21 L0.502173913,17.2565217 C0.730434783,16.023913 1.82608696,15.2934783 3.05869565,15.0195652 L10.5,13.6956522 L17.9413043,15.0195652 C19.173913,15.2934783 20.2695652,16.023913 20.4521739,17.2565217 L21,21",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0d40ea6f.svg";
export { ForwardRef as ReactComponent };